export default {"src":"/_next/static/media/desktop-computer.b47dbffd.svg","height":24,"width":24};